import * as React from 'react'
import {Form} from '@patternfly/react-core'
import {GenericTextArea} from '../../../components/GenericTextArea'
import {valutaIscrizioneOrdine} from 'src/processes/ProcessoIscrizione'
import {inputRequiredValidation} from 'src/utilities/utility'

export class FormRichiediIntegrazioni extends React.Component<GeneralFormRichiediIntegrazioniProps, any> {

    handleSubmit = async event => {
        /*--------------------------------------------- Validazione campi obbligatori ------------------------------------------------*/
        var requiredFields = [
            { value: event.target.idIntegrazioni.value, label: 'Integrazioni richieste' },
        ]

        var errorRequired: any = inputRequiredValidation(requiredFields)
        if (errorRequired !== undefined && errorRequired !== "") {
            event.preventDefault()
            return this.props.messaggio({ messaggio: errorRequired.messaggio, type: errorRequired.type })
        }
        /*-----------------------------------------------------------------------------------------------------------------------------*/
        else {
            //chiamata al servizio valutaIscrizione per richiesta integrazioni iscrizione
            var esitoValutazione = "richiesta_integrazioni"
            var idIscrizione = this.props.idIscrizione
            var idSoggetto = this.props.idSoggetto
            var parametriRichiestaIntegrazioni = {
                integrazioniRichieste: event.target.idIntegrazioni.value ? event.target.idIntegrazioni.value : ""
            }
            try {
                event.preventDefault();
                await valutaIscrizioneOrdine(esitoValutazione, idIscrizione, idSoggetto, parametriRichiestaIntegrazioni, [])

                return this.props.messaggio({ messaggio: "Dati salvati con successo", type: "success" })
            }
            catch (err) {
                return this.props.messaggio({ messaggio: "C'è stato un problema nell'invio dei dati", type: "danger" })
            }
        }
    }

    render() {
        return (
            <div>
                <Form id='idRichiediIntegrazioni' onSubmit={this.handleSubmit}>
                    <GenericTextArea className='w-50' id={"idIntegrazioni"} label={"Integrazioni richieste"} name={"integrazioniRichiesteName"} placeholder={"Inserire integrazioni"} ariaLabel={'textarea-integrazionIRichieste'} isRequired />
                </Form>
            </div>
        )
    }
}

export declare interface GeneralFormRichiediIntegrazioniProps {
    messaggio?: any;
    idIscrizione?: any;
    idSoggetto?: any;
}
